// extracted by mini-css-extract-plugin
export default {"menu":"MoreMenu_menu__hT0O4"};